import Swiper, { Navigation, Scrollbar } from 'swiper';
import 'swiper/css';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// window load event listener allows for JS to run in the CMS editor.
window.addEventListener('load', (e) => {
	const caseSwipers = document.querySelectorAll('.case-studies .swiper');

	caseSwipers.forEach((caseSwiper, index) => {
		let slider = new Swiper(caseSwiper, {
			modules: [Navigation, Scrollbar],
			speed: 400,
			spaceBetween: 30,
			slidesPerView: 1,
			navigation: {
				enabled: false
			},
			scrollbar: {
				enabled: true,
				el: caseSwiper.querySelector('.swiper-scrollbar'),
				draggable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 3,
					navigation: {
						enabled: true,
						nextEl: caseSwiper.parentElement.parentElement.querySelector('.swiper-button-next'),
						prevEl: caseSwiper.parentElement.parentElement.querySelector('.swiper-button-prev'),
					},
					scrollbar: {
						enabled: false
					},
				}
			}
		});
	});

	// counter
	function counter(start, end, element) {
		let current = start;

		if(start <= end) {
			element.innerHTML = current;

			current = start + 1;

			setTimeout(() => {
				counter(current, end, element);
			}, 50);
		}
	}


	let counterElem = document.querySelector('.case-studies .count-up');
	let section = document.querySelector('.case-studies');

	gsap.from(section, {
		scrollTrigger: {
			trigger: section,
			start: '50% center',
			onEnter: () => {
				counter(0, counterElem.innerHTML, counterElem);
			}
		}
	});
	


});
